import React from 'react';
import Hero from './HeroArea';
import About from './AboutArea';
import Service from './ServiceArea';
import ChooseUs from './ChooseArea';
import Contact from './ContactArea';
import Testimonial from './TestimonialArea';
import Blog from './BlogArea';
import FunFact from './FunfactArea';

const HomeFiveMain = () => {
  return (
    <main>
      <Hero />
      <About />
      <Service />
      <ChooseUs />
      <Contact />
      <Testimonial />
      <FunFact />
      <Blog />
    </main>
  );
};

export default HomeFiveMain;
